var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagnifierIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.58317 2.29169C5.5561 2.29169 2.2915 5.55628 2.2915 9.58335C2.2915 13.6104 5.5561 16.875 9.58317 16.875C13.6102 16.875 16.8748 13.6104 16.8748 9.58335C16.8748 5.55628 13.6102 2.29169 9.58317 2.29169ZM1.0415 9.58335C1.0415 4.86592 4.86574 1.04169 9.58317 1.04169C14.3006 1.04169 18.1248 4.86592 18.1248 9.58335C18.1248 11.7171 17.3424 13.6681 16.0489 15.1652L18.7751 17.8914C19.0192 18.1355 19.0192 18.5312 18.7751 18.7753C18.531 19.0194 18.1353 19.0194 17.8912 18.7753L15.165 16.0491C13.668 17.3426 11.7169 18.125 9.58317 18.125C4.86574 18.125 1.0415 14.3008 1.0415 9.58335Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifierIcon);
export default __webpack_public_path__ + "static/media/magnifier-icon.faf60080e6a1a5f8bf2378b02a9ae6b9.svg";
export { ForwardRef as ReactComponent };